import angular from 'angular';
import plansConfig from './plans.config';

import plans from '../../containers/plans';

const plansModule = angular.module('meredicte.plans', [])
  .component('appPlans', plans)
  .config(plansConfig);

export default plansModule;



// WEBPACK FOOTER //
// ./src/modules/plans/plans.module.js